import { Validator } from '@vista-digital/validator';
/**
 * Regex format for SVG viewBox strings. Supports space or comma separators, negative coordinates, and decimal values.
 * Valid formats:
 * 0 0 100 100
 * 0,0,100,100
 * -5 -5 100 100
 * 0.5 0.5 0.5 0.5
 */
const viewBoxValidationFormat = new RegExp('^-?\\d+(\\.\\d+)?(\\s|,|,\\s)-?\\d+(\\.\\d+)?(,|\\s|,\\s)\\d+(\\.\\d+)?(,|\\s|,\\s)\\d+(\\.\\d+)?$');
export const viewBoxStringValidator = Validator.string({ minLength: 7, format: viewBoxValidationFormat });
//# sourceMappingURL=view-box-validator.js.map